import { DashboardSection } from './sections/DashboardSection';

export default function Home() {
  return <DashboardSection />;
}
